import PropTypes from 'prop-types';
import PropsType from 'props-type';
import { useDispatch } from 'react-redux';

import { modalClose } from '@app/store/modal/actions';

import './DocumentPollingErrorAlertModal.scss';

const propTypes = {
  message: PropTypes.string.isRequired,
};

type DocumentPollingErrorAlertModalProps = PropsType<typeof propTypes>;

function DocumentPollingErrorAlertModal({ message }: DocumentPollingErrorAlertModalProps) {
  const dispatch = useDispatch();
  return (
    <div className="Container Container--max-xxs">
      <div className="Card Card--pop align-center box-6x">
        <h4 className="space-3x" data-testid="basic-modal-title">
          <strong>서명 요청 완료 및 상태 오류</strong>
        </h4>
        <p className="space-3x">
          서명 요청은 완료되었으나,
          <br />
          아래 이유로 문서의 상태를 확인할 수 없습니다.
          <br />
          잠시 후 새로고침하여 확인해 주세요.
          <br />
        </p>
        <div className="Card Card--primary Card--theme-flat align-left space-4x DocumentPollingErrorAlertModal__message">
          {message}
        </div>
        <button
          className="Btn Btn--primary Btn--bold-mobile"
          type="button"
          onClick={() => {
            dispatch(modalClose());
          }}
        >
          확인
        </button>
      </div>
    </div>
  );
}

export default DocumentPollingErrorAlertModal;
